import { Pipe, PipeTransform } from '@angular/core';
import { AllocationCard, AllocationView, AllocationViewColorField } from '@jms/model';

@Pipe({
    name: 'cardColorValue',
    standalone: true
})
export class CardColorValuePipe implements PipeTransform {

    transform(allocation: AllocationCard, view: AllocationView): any {

        let primary: any;

        switch (view?.color) {
            case AllocationViewColorField.JobType:
                primary = allocation?.meta?.type;
                break;
            case AllocationViewColorField.Priority:
                primary = allocation?.meta?.priority;
                break;
            case AllocationViewColorField.WorkCategory:
                primary = allocation?.meta?.category;
                break;
            case AllocationViewColorField.Status:
                primary = allocation?.meta?.status;
                break;
        }

        return primary;
    }
}